import React from 'react';
import { orderValidForQuote, CurrentStep, rateImpactingFields, } from './Quote';
import { Sidebar } from './Sidebar';
import { getCurrentQuote, submitOrder, getOrder, updateOrder, } from '../api';
import { QuoteForm } from './QuoteForm';
export const QuoteBuilder = ({ orderId, }) => {
    const [order, setOrder] = React.useState({
        organization_attributes: {
            address_attributes: {},
        },
        contact_attributes: {},
        event_attributes: {
            address_attributes: {},
        },
    });
    const [quote, setQuote] = React.useState(null);
    const [currentStep, setCurrentStep] = React.useState(CurrentStep.Core);
    const [valid, setValid] = React.useState(false);
    const [quickQuotable, setQuickQuotable] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [hasSubmitted, setHasSubmitted] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const rateImpactingOrderFields = React.useMemo(() => rateImpactingFields(order), [order]);
    const handleQuoteResponse = (data) => {
        setHasSubmitted(true);
        if ('errors' in data) {
            setQuote(null);
            setQuickQuotable(data.quick_quotable);
        }
        else {
            setErrors([]);
            setQuote(data);
            setQuickQuotable(true);
        }
    };
    const quoteOrder = async () => {
        setLoading(true);
        try {
            const data = await getCurrentQuote(order);
            handleQuoteResponse(data);
            if ('errors' in data) {
                setErrors(data.errors);
            }
        }
        catch {
            setErrors([
                {
                    field: 'general',
                    label: '',
                    messages: [
                        'Something went wrong, please contact smic_information@amwins.com with information on your request.',
                    ],
                },
            ]);
        }
        setLoading(false);
    };
    const fetchCurrentOrder = async () => {
        if (orderId) {
            const data = await getOrder(orderId);
            setOrder(data);
            setValid(true);
            setCurrentStep(CurrentStep.Event);
        }
    };
    const onContinue = async () => {
        await quoteOrder();
        setCurrentStep(CurrentStep.Event);
    };
    React.useEffect(() => {
        fetchCurrentOrder();
    }, [orderId]);
    React.useEffect(() => {
        const element = document.getElementById('organization-form');
        if (element && !orderId) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [currentStep, orderId]);
    React.useEffect(() => {
        if (currentStep === CurrentStep.Core) {
            setValid(orderValidForQuote(rateImpactingOrderFields));
        }
    }, [JSON.stringify(rateImpactingOrderFields), currentStep, errors]);
    React.useEffect(() => {
        if (valid) {
            quoteOrder();
        }
    }, [JSON.stringify(rateImpactingOrderFields), valid]);
    const onSubmit = async () => {
        setLoading(true);
        let newErrors = [];
        if (order.organization_attributes?.has_additional_insureds === undefined) {
            newErrors = newErrors.concat([
                {
                    field: 'has_additional_insureds',
                    label: '',
                    messages: ["Must select 'Yes' or 'No' for having additional insured"],
                },
            ]);
        }
        if (order.organization_attributes?.has_insurance_losses === undefined) {
            newErrors = newErrors.concat([
                {
                    field: 'has_insurance_losses',
                    label: '',
                    messages: ["Must select 'Yes' or 'No' for having insurance losses"],
                },
            ]);
        }
        const quoteResponse = await getCurrentQuote(order);
        handleQuoteResponse(quoteResponse);
        if ('errors' in quoteResponse) {
            newErrors = newErrors.concat(quoteResponse.errors);
        }
        if (orderId) {
            const response = await updateOrder(orderId, order);
            if (response && 'errors' in response) {
                newErrors = newErrors.concat(response.errors);
            }
            else {
                window.location.href = `/orders/${orderId}/payments/new`;
            }
        }
        else if (newErrors.length === 0) {
            const response = await submitOrder(order);
            if ('id' in response) {
                window.location.href = `/orders/${response.id}/payments/new`;
            }
            else {
                newErrors = newErrors.concat(response.errors);
            }
        }
        setErrors(newErrors);
        setLoading(false);
    };
    return (React.createElement("div", { className: "sidebar__wrapper" },
        React.createElement("div", { className: "content" },
            React.createElement(QuoteForm, { currentStep: currentStep, order: order, errors: errors, onChange: (o) => setOrder(o) })),
        React.createElement(Sidebar, { hasSubmitted: hasSubmitted, quote: quote, loading: loading, quickQuotable: quickQuotable, errors: errors, onSubmit: currentStep >= CurrentStep.Event ? onSubmit : undefined, onContinue: currentStep === CurrentStep.Core && valid ? onContinue : undefined })));
};
